// extracted by mini-css-extract-plugin
module.exports = {"call__icon":"cv_p2","call__phone":"cv_p3"};